import React from "react";
import { Card, Table } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from "moment";
import isEqual from "react-fast-compare";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

export default class TrackResultSampleDisplaySpecies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      samples: this.props.roomDetails.sample_areas,
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.roomName, this.props.roomName)) {
      this.setState({
        samples: this.props.roomDetails.sample_areas,
      });
    }
  }

  getColour = () => {
    let colour = ''
    if(this.props.roomDetails.sample_areas.length>0){
      if(this.props.roomDetails.sample_areas[0].speciesResult.species_type__count >=1 && this.props.roomDetails.sample_areas[0].speciesResult.species_type__count <=9){
        colour = '#F5F9A3'
      }
      else if(this.props.roomDetails.sample_areas[0].speciesResult.species_type__count >=10 && this.props.roomDetails.sample_areas[0].speciesResult.species_type__count <=24){
        colour = '#B4E892'
      }
      else if(this.props.roomDetails.sample_areas[0].speciesResult.species_type__count >=25 && this.props.roomDetails.sample_areas[0].speciesResult.species_type__count <=49){
        colour = '#AED6ED'
      }
      else if(this.props.roomDetails.sample_areas[0].speciesResult.species_type__count >=50 && this.props.roomDetails.sample_areas[0].speciesResult.species_type__count <=74){
        colour = '#DBBEED'
      }
      else if(this.props.roomDetails.sample_areas[0].speciesResult.species_type__count >=75 && this.props.roomDetails.sample_areas[0].speciesResult.species_type__count <=100){
        colour = '#D39595'
      }
    }
      return colour
  }

  render() {
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1530,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            infinite: false,
          }
        },
        {
          breakpoint: 1160,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            infinite: false,
          }
        },
        {
          breakpoint: 730,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            infinite: false,
          }
        }
      ],
    };
    return (
      <div className="carousel track-result-cord">
        <Row className="d-flex justify-content-between bd-highlight mb-2">
          <Col className="bd-highlight room-name ">{" "}{this.props.roomName ? this.props.roomName : null}</Col>
        </Row>
        {this.state.samples.length > 0 ? (
          <Slider {...settings}>
            <Card className="sample-card" style={{ height: "103px !importent" }}>
              <Card.Body className="d-flex  candidate-card" style={{ padding: "0.5rem 0.3rem " }}>
                <div
                  className="track-result-sample-box"
                  style={{ 
                    backgroundColor: this.getColour() }}
                ></div>
                <Table style={{ marginBottom: 0 }} borderless>
                  <tbody>
                    {this.props.roomDetails.sample_areas.length> 0?
                      <>
                        <tr>
                          <td>
                            Species Name: {this.props.roomDetails.sample_areas[0].speciesResult.species_type ? this.props.roomDetails.sample_areas[0].speciesResult.species_type : ''}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Total count of Samples: {this.props.roomDetails.locationObject.samples.length ? this.props.roomDetails.locationObject.samples.length : 0}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Average Species Percentage: {this.props.roomDetails.sample_areas[0].speciesResult.species_type__count ? this.props.roomDetails.sample_areas[0].speciesResult.species_type__count.toFixed(2) : 0}%
                          </td>
                        </tr>
                      </>
                      :
                      null}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Slider>
        ) : (
          <div className="no-msg-text">No species found in this room.</div>
        )}
      </div>
    );
  }
}
